import { render, staticRenderFns } from "./Pop.vue?vue&type=template&id=6b2f1a9a&"
import script from "./Pop.vue?vue&type=script&lang=js&"
export * from "./Pop.vue?vue&type=script&lang=js&"
import style0 from "./pop.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports